import React, { FC } from 'react';
import useTheme from '@mui/material/styles/useTheme';
import { SxProps, Theme } from '@mui/material/styles';

import Box from '@mui/material/Box';

import iconSet from 'assets/icons/selection.json';
import IcomoonReact from 'icomoon-react';

type Props = {
  icon: string;
  size?: number;
  sx?: SxProps<Theme>;
};

const Icon: FC<Props> = ({ icon, size = 20, sx }) => {
  const { palette } = useTheme();

  return (
    <Box sx={sx}>
      <IcomoonReact
        iconSet={iconSet}
        icon={icon.replace('icon-', '')}
        color={palette.text.primary}
        size={size}
      />
    </Box>
  );
};

export default Icon;
